const name = 'circle-r';

const contents = '<path d="M33.456 26.829c2.983 0 5.317.814 7.002 2.444 1.685 1.63 2.527 3.797 2.527 6.504 0 1.878-.414 3.522-1.243 4.93-.828 1.409-2.21 2.39-4.143 2.942v.414L43.98 55H37.6l-5.551-10.357h-4.972V55h-5.634V26.829h12.014zm-.58 4.64h-5.8v8.534h5.8c1.326 0 2.403-.345 3.232-1.036.828-.69 1.243-1.754 1.243-3.19 0-1.38-.415-2.444-1.243-3.19-.829-.746-1.906-1.118-3.232-1.118z" fill="#FFF"/>';

/** @type {import ('./types').CharacterIcon} */
const icon = {
  name,
  contents,
  iconCharacter: 'R',
};

export default icon;
